import { ReactElement } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Box } from '@mui/material';
import { Match } from 'effect';

import type { LoggerMasterStatus } from '../../types/Logger';

interface Props {
    inModal?: boolean;
    status: LoggerMasterStatus | undefined;
    message: string | undefined;
}

const LoggerStatusJsx = ({ inModal = false, message = 'N/A', status }: Props): ReactElement => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: inModal ? 'row' : 'column',
                alignItems: 'center'
            }}
            data-testid="logger-status"
        >
            {matchLoggerStatusToIcon(status)}

            <Box
                sx={
                    inModal
                        ? undefined
                        : {
                              fontSize: '0.75rem',
                              marginTop: '2px',
                              lineHeight: '14px'
                          }
                }
            >
                {message}
            </Box>
        </Box>
    );
};

const matchLoggerStatusToIcon = (status?: LoggerMasterStatus) => {
    return Match.type<typeof status>().pipe(
        Match.when('passed', () => (
            <CheckCircleIcon sx={{ fontSize: '24px' }} color="success" data-testid="passed-icon" />
        )),
        Match.when('failed', () => <ErrorIcon sx={{ fontSize: '24px' }} color="error" data-testid="failed-icon" />),
        Match.when('inspect', () => <ErrorIcon sx={{ fontSize: '24px' }} color="warning" data-testid="inspect-icon" />),
        // in the case of missing status, we will show a icon indicating as much
        Match.orElse(() => <CancelIcon sx={{ fontSize: '24px' }} color="disabled" data-testid="missing-icon" />)
    )(status);
};

export default LoggerStatusJsx;
